import { render, staticRenderFns } from "./productInvalid.vue?vue&type=template&id=703028d2&"
import script from "./productInvalid.vue?vue&type=script&lang=js&"
export * from "./productInvalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports